import { render, staticRenderFns } from "./CodeVerification.vue?vue&type=template&id=1c276e48&scoped=true&"
import script from "./CodeVerification.vue?vue&type=script&lang=js&"
export * from "./CodeVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c276e48",
  null
  
)

export default component.exports